import { Ability, AbilityBuilder } from "@casl/ability";
import { initialAbility } from "./config";
import { ROLES, ACTIONS, SUBJECT, USER_TYPE } from "@/const/acl";
import { getLocalUserData, getRules, getRole } from "@/util/userData";

export class AuthType {
    static modelName = "AuthType";
    constructor(pageType) {
        this.pageType = pageType;
    }
}

export const defineAbilitiesFor = user => {
    const { can, cannot, rules } = new AbilityBuilder();
    can(ACTIONS.READ, SUBJECT.NON_AUTH); // 未認証ページは全てのユーザが見れる
    if (user.role === ROLES.ADMIN) {
        can(ACTIONS.MANAGE, SUBJECT.ALL);
        can(ACTIONS.READ, AuthType, { pageType: SUBJECT.ALL });
    } else if (user.role === ROLES.MEMBER) {
        can(ACTIONS.READ, AuthType, { pageType: SUBJECT.ALL });
        if (user.type === USER_TYPE.KAISEKISHI) {
            can(ACTIONS.READ, AuthType, { pageType: SUBJECT.COMPASS });
            can(ACTIONS.READ, AuthType, { pageType: SUBJECT.MASTERCHART });
            can(ACTIONS.READ, AuthType, { pageType: SUBJECT.PASSPORT });
            can(ACTIONS.READ, AuthType, { pageType: SUBJECT.FORTUNE });
        } else if (user.type === USER_TYPE.KOZA) {
            can(ACTIONS.READ, AuthType, { pageType: SUBJECT.MASTERCHART });
        } else if (user.type === USER_TYPE.NINTEI) {
            can(ACTIONS.READ, AuthType, { pageType: SUBJECT.COMPASS });
            can(ACTIONS.READ, AuthType, { pageType: SUBJECT.MASTERCHART });
        }
    } else {
        cannot(ACTIONS.READ, AuthType, { pageType: SUBJECT.ALL });
    }
    return rules;
};

let existingAbility = null;
const userData = getLocalUserData(); // JSON.parse(localStorage.getItem("userData"));
if (userData) {
    if (getRole() === userData.role) {
        existingAbility = getRules();
    }
}

export default new Ability(existingAbility || initialAbility);
